import AirConditioner from './components/Icons/AirConditioner'
import Bbq from './components/Icons/Bbq'
import CheckInCheckOut from './components/Icons/CheckInCheckOut'
import CleaningSupplies from './components/Icons/CleaningSupplies'
import Contacts from './components/Icons/Contacts'
import DefaultSection from './components/Icons/DefaultSection'
import Fireplaces from './components/Icons/Fireplaces'
import HomeAndNeighborhood from './components/Icons/HomeAndNeighborhood'
import ImportantReminders from './components/Icons/ImportantReminders'
import LaundryAndIroning from './components/Icons/LaundryAndIroning'
import LeftSomethingBehind from './components/Icons/LeftSomethingBehind'
import LocalRecommendations from './components/Icons/LocalRecommendations'
import Parking from './components/Icons/Parking'
import PoolSpa from './components/Icons/PoolSpa'
import Tv from './components/Icons/Tv'
import Wifi from './components/Icons/Wifi'

export type HomeManualFieldProjection = {
  title: string
  value: string
  defaultValue: string
  listOrder: number
  key: string
}

export type Sections = Array<HomeManualFieldProjection>

export type SetStateType = (nextSection: HomeManualFieldProjection | null) => void

export const Icons = {
  airConditioner: AirConditioner,
  bbq: Bbq,
  checkInCheckOut: CheckInCheckOut,
  cleaningSupplies: CleaningSupplies,
  contacts: Contacts,
  defaultSection: DefaultSection,
  fireplaces: Fireplaces,
  homeAndNeighborhood: HomeAndNeighborhood,
  importantReminders: ImportantReminders,
  laundryAndIroning: LaundryAndIroning,
  leftSomethingBehind: LeftSomethingBehind,
  localRecommendations: LocalRecommendations,
  parking: Parking,
  poolSpa: PoolSpa,
  tv: Tv,
  wifi: Wifi,
}
